import React, { useState } from 'react';
import OrderListTemplate from '../components/OrderListTemplate';
import { MergedOrder, OrderTabScene } from '../../../types/process/order';
import OrderTriggerActionMap, { OrderTriggerActionProvider, type OrderTriggerTarget } from '../components/OrderTriggerActionMap';
import { getOrderAuditDisplayName, useDefaultQueryFields } from '../order.effect';
import { Typography } from 'antd';
import { useStaffMap } from '../../../services/store/organization.store';
import { AuditStatusMap } from '../../../types/process/order-audit';
const { Text } = Typography;
/**
 * 所有已审订单列表页
 */
const OrderAllAuditList: React.FC = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const { staffMap } = useStaffMap();
  /**
   * 触发列表重载
   */
  const reloadList = () => setRefreshKey((k) => k + 1);

  const queryFields = useDefaultQueryFields(OrderTabScene.GroupAllAuditDone);

  const targets: OrderTriggerTarget[] = ['auditView', 'cancelByOrder'];

  const renderListInfo = (order: MergedOrder) => {
    const displayNames = getOrderAuditDisplayName(order, staffMap);
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <Text style={{ color: '#1677ff' }}>审核人: {displayNames}</Text>
        <Text style={{ color: '#1677ff' }}>审核结论: {AuditStatusMap[order.order.auditStatus] || '-'}</Text>
      </div>
    );
  };

  const renderListActions = (order: MergedOrder) => {
    return (
      <OrderTriggerActionMap layout="list" targets={targets} order={order} onReload={reloadList} />
    );
  };

  return (
    <OrderTriggerActionProvider onReload={reloadList}>
      <OrderListTemplate
        title="所有已审"
        refreshKey={refreshKey}
        tabScene={OrderTabScene.GroupAllAuditDone}
        defaultScene="tab_all_audit_done"
        queryFields={queryFields}
        viewModes={[
          { mode: 'list', label: '订单页', renderActions: renderListActions, renderInfo: renderListInfo },
          { 
            mode: 'table', 
            label: '表格页',
            showField: 'auditStep',
            // renderActions: renderTableActions,
          },
        ]}
      />
    </OrderTriggerActionProvider>
  );
};

export default OrderAllAuditList;
